import { AppSection } from './AppSection';
// import { Calculator } from './components/Calculator/Calculator';
import { createTranslate, createTranslateContent } from 'internalLibrary';
import { LogoImage, LogoSquareImage } from './assets';
// import { logout } from './actions/logout';
// import { Navbar } from './components/Navbar/Navbar';
import { RegistrationFrameConfig } from './types/ui';
import panelStyles from 'ui/components/LoanApplicationProcessLayout/Sidebar/Sidebar.module.scss';
import se from './localizations/se';
const translate = createTranslate(se);
const translateContent = createTranslateContent(se);
const contact = translateContent('contact');

export interface AppConfig {
  age: { min: number; max: number };
  productNumber: string;
  phone: string;
  email: string;
  businessHours: string;
  originUrl: string;
  formatting: {
    nbspSymbol: string;
    numberDelimeter: string;
    numberGroupSize: number;
    numberPrecision: number;
    defaultDateFormat: string;
  };
  // frame
  frameConfig: RegistrationFrameConfig;
  frameConfigWithNoPanels: RegistrationFrameConfig;
}

export const frameConfigWithNoPanels: AppConfig['frameConfigWithNoPanels'] = {
  // calculatorDesktop: Calculator,
  // calculatorMobile: Calculator,
  logoSquare: <LogoSquareImage />,
  logo: <LogoImage />,
  onLogoutButtonClick: undefined,
  frameContent: translateContent('common'),
  footerMobile: {
    content: { logout: translate('common.logout'), ...contact },
    image: (
      <div className={panelStyles['credit-control']}>
        <img
          src="/images/credit-safe-logo.png"
          alt={translate('leftPanel.creditSafeLogoAlt')}
        />
      </div>
    ),
  },
};

export const frameConfig: AppConfig['frameConfig'] = {
  ...frameConfigWithNoPanels,
  // navbar: Navbar,
  // panel: Sidebar,
  sections: [
    {
      id: AppSection.Registration,
      title: translate('progress.registration'),
    },
    {
      id: AppSection.Identification,
      title: translate('progress.identification'),
    },
    {
      id: AppSection.Verification,
      title: translate('progress.verification'),
    },
  ],
};

export const config: AppConfig = {
  originUrl: 'https://www.vivus.se',
  frameConfig,
  frameConfigWithNoPanels,
  age: { max: 80, min: 18 },
  productNumber: '15',
  ...contact,
  formatting: {
    nbspSymbol: '\xa0',
    numberDelimeter: ',',
    numberGroupSize: 3,
    numberPrecision: 2,
    defaultDateFormat: 'YYYY-MM-DD',
  },
};
